import { DecimalPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'frma-currency-input',
  templateUrl: './frma-currency-input.component.html',
  styleUrls: ['./frma-currency-input.component.css']
})
export class FrmaCurrencyInputComponent implements OnInit {

  static localIterator = 1;
  private allowedKeys = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Control', 'Delete', 'Enter', 'NumLock', '.', ','];
  private _amount: number;
  public get amount(): number {
  return this._amount;
  }
  @Input() public set amount(value: number) {
    if (value != this._amount) {
      this._amount = value;
      if (value) {
        this.formattedAmount = this.decimalPipe.transform(value, '1.2-2');
      }
    }
  }
  @Output() amountChange = new EventEmitter<number>();
  formattedAmount: string;
  localId: number;
  constructor(
    private decimalPipe: DecimalPipe
  ) {
    this.localId = FrmaCurrencyInputComponent.localIterator++;
  }

  ngOnInit(): void {}

  onChange() {
    this._amount = Number(this.formattedAmount.replace(/,/g, ''));
    this.amountChange.emit(this.amount);
  }

  onBlur() {
    this.formattedAmount = this.decimalPipe.transform(this.formattedAmount, '1.2-2');
  }

  onFocus() {
    this.formattedAmount = this.formattedAmount.replace(/,/g, '');
  }

}
